import { LitElement, html, css } from 'lit'
import { html as staticHtml, unsafeStatic } from 'lit/static-html.js'
import { setupRouter } from '../router.js'

class AppRouter extends LitElement {
  static properties = {
    currentRoute: { type: Object }
  }

  static styles = css`
    .loading { padding: 3rem; text-align: center; color: var(--zg-muted); }
  `

  connectedCallback() {
    super.connectedCallback()
    this._teardown = setupRouter(this)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this._teardown?.()
  }

  render() {
    const route = this.currentRoute
    if (!route || route.component === 'app-loading') {
      return html`<div class="loading">Loading…</div>`
    }
    const tag = unsafeStatic(route.component)
    return staticHtml`<${tag} .params=${route.params || []}></${tag}>`
  }
}

customElements.define('app-router', AppRouter)
